<template>
    <section class="three-ways-section">
      <div class="container">
        <!-- Titre principal -->
        <div class="section-header text-center">
          <h2 class="section-title">{{ t('threeways.title') }}</h2>
        </div>
  
        <!-- Onglets de navigation -->
        <div class="tabs-navigation">
          <div class="tabs-wrapper">
            <button 
              class="tab-btn" 
              :class="{ active: activeTab === 'nfc' }"
              @click="activeTab = 'nfc'"
            >
              <i class="fas fa-id-card"></i>
              <span class="tab-text">{{ t('threeways.tabs.nfc') }}</span>
            </button>
            <button 
              class="tab-btn" 
              :class="{ active: activeTab === 'linkinbio' }"
              @click="activeTab = 'linkinbio'"
            >
              <i class="fas fa-link"></i>
              <span class="tab-text">{{ t('threeways.tabs.linkinbio') }}</span>
            </button>
            <button 
              class="tab-btn" 
              :class="{ active: activeTab === 'qrcode' }"
              @click="activeTab = 'qrcode'"
            >
              <i class="fas fa-qrcode"></i>
              <span class="tab-text">{{ t('threeways.tabs.qrcode') }}</span>
            </button>
          </div>
        </div>
  
        <!-- Contenu des onglets -->
        <div class="tab-content">
          <div class="content-wrapper">
          <!-- Link In Bio -->
          <transition name="fade" mode="out-in">
            <div v-if="activeTab === 'linkinbio'" key="linkinbio" class="tab-pane-content">
              <div class="content-card">
                <div class="row align-items-center">
                  <div class="col-lg-6 mb-3 mb-lg-0">
                    <div class="content-box">
                      <h3 class="content-title">{{ t('threeways.linkinbio.title') }}</h3>
                      <p class="content-description">
                        {{ t('threeways.linkinbio.description') }}
                      </p>
                      
                      <div class="feature-list">
                        <div class="feature-item-mini">
                          <div class="check-icon">
                            <i class="fas fa-check"></i>
                          </div>
                          <span>{{ t('threeways.linkinbio.features.unlimited') }}</span>
                        </div>
                        <div class="feature-item-mini">
                          <div class="check-icon">
                            <i class="fas fa-check"></i>
                          </div>
                          <span>{{ t('threeways.linkinbio.features.customizable') }}</span>
                        </div>
                        <div class="feature-item-mini">
                          <div class="check-icon">
                            <i class="fas fa-check"></i>
                          </div>
                          <span>{{ t('threeways.linkinbio.features.statistics') }}</span>
                        </div>
                      </div>
  
                      <div class="taap-claim">
                        <p class="claim-label">{{ t('threeways.linkinbio.claim.label') }}</p>
                        <div class="claim-input-group">
                          <span class="input-prefix">neolinks.me/</span>
                          <input type="text" :placeholder="t('threeways.linkinbio.claim.placeholder')" class="claim-input" />
                          <router-link to="/inscription" class="btn-start">{{ t('threeways.linkinbio.claim.button') }}</router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="visual-box">
                        <img src="@/assets/images/ggg1.webp" alt="Link in Bio" class="preview-img-mockup preview-img-profile" @error="handleImageError" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
  
          <!-- Digital Business Card (NFC) -->
          <transition name="fade" mode="out-in">
            <div v-if="activeTab === 'nfc'" key="nfc" class="tab-pane-content">
              <div class="content-card">
                <div class="row align-items-center">
                  <div class="col-lg-5 mb-3 mb-lg-0 order-lg-1">
                    <div class="visual-box">
                      <img src="@/assets/images/ggg2.webp" alt="NFC Cards" class="preview-img" @error="handleImageError" />
                    </div>
                  </div>
                  <div class="col-lg-6 order-lg-2">
                    <div class="content-box">
                      <h3 class="content-title">{{ t('threeways.nfc.title') }}</h3>
                      <p class="content-description">
                        {{ t('threeways.nfc.description') }}
                      </p>
                      
                      <div class="cards-list">
                        <div class="card-badge white">
                          <span class="badge-label">{{ t('threeways.nfc.cards.white.name') }}</span>
                          <span class="badge-desc">{{ t('threeways.nfc.cards.white.desc') }}</span>
                        </div>
                        <div class="card-badge silver">
                          <span class="badge-label">{{ t('threeways.nfc.cards.silver.name') }}</span>
                          <span class="badge-desc">{{ t('threeways.nfc.cards.silver.desc') }}</span>
                        </div>
                        <div class="card-badge golden">
                          <span class="badge-label">{{ t('threeways.nfc.cards.golden.name') }}</span>
                          <span class="badge-desc">{{ t('threeways.nfc.cards.golden.desc') }}</span>
                        </div>
                      </div>
  
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
  
          <!-- Digital Sharing -->
          <transition name="fade" mode="out-in">
            <div v-if="activeTab === 'qrcode'" key="qrcode" class="tab-pane-content">
              <div class="content-card">
                <div class="row align-items-center justify-content-center">
                  <div class="col-lg-6 mb-3 mb-lg-0 text-center text-lg-start">
                    <div class="content-box">
                      <h3 class="content-title">{{ t('threeways.qrcode.title') }}</h3>
                      <p class="content-description">
                        {{ t('threeways.qrcode.description') }}
                      </p>
                      
                      <div class="feature-list">
                        <div class="feature-item-mini">
                          <div class="check-icon">
                            <i class="fas fa-check"></i>
                          </div>
                          <span>{{ t('threeways.qrcode.features.customizable') }}</span>
                        </div>
                        <div class="feature-item-mini">
                          <div class="check-icon">
                            <i class="fas fa-check"></i>
                          </div>
                          <span>{{ t('threeways.qrcode.features.multiplatform') }}</span>
                        </div>
                        <div class="feature-item-mini">
                          <div class="check-icon">
                            <i class="fas fa-check"></i>
                          </div>
                          <span>{{ t('threeways.qrcode.features.analytics') }}</span>
                        </div>
                 
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="visual-box">
                      <img src="@/assets/images/ggg0.webp" alt="Digital Sharing" class="preview-img-mockup" @error="handleImageError" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { ref } from 'vue'
  import { useTranslation } from '@/composables/useTranslation'
  
  export default {
    name: 'ThreeWaysSection',
    setup() {
      const { t } = useTranslation()
      const activeTab = ref('nfc')
      
      const handleImageError = (e) => {
        e.target.style.display = 'none'
      }
      
      return {
        t,
        activeTab,
        handleImageError
      }
    }
  }
  </script>
  


  <style lang="scss" scoped>
$text-dark: #222;
$text-gray: #666;
$border-color: #e5e7eb;

.three-ways-section {
  padding: 3rem 0;
  background-color: #ffffff;

  @media (max-width: 992px) {
    padding: 2rem 0;
  }
}

.section-header {
  margin-bottom: 2rem;

  .section-title {
    font-size: 1.625rem;
    font-weight: 700;
    color: $text-dark;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 1.375rem;
    }
  }
}

// Onglets - Version ultra compacte
.tabs-navigation {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
}

.tabs-wrapper {
  display: inline-flex;
  background-color: #f3f4f6;
  border-radius: 50px;
  padding: 0.25rem;
  gap: 0.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    flex-direction: row;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    border-radius: 50px;
  }
}

.tab-btn {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: $text-gray;
  background-color: transparent;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;

  i {
    font-size: 0.75rem;
  }

  &:hover {
    color: $text-dark;
    background-color: rgba(0, 0, 0, 0.04);
  }

  &.active {
    color: #fff;
    background-color: #000;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    justify-content: center;
    border-radius: 50px;
    padding: 0.625rem;
    gap: 0;
    
    i {
      font-size: 1rem;
    }

    .tab-text {
      display: none;
    }
  }
}

// Contenu
.tab-content {
  min-height: 300px;
}

.content-wrapper {
  max-width: 1000px;
  margin: 0 auto;

  @media (max-width: 1200px) {
    max-width: 900px;
  }

  @media (max-width: 992px) {
    max-width: 100%;
  }
}

.tab-pane-content {
  animation: fadeIn 0.35s ease;
}

// Card gris avec bordure subtile - Plus compacte
.content-card {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 1.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  @media (max-width: 992px) {
    padding: 1.5rem;
  }

  @media (max-width: 576px) {
    padding: 1.25rem;
  }
}

.content-box {
  .content-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: $text-dark;
    margin-bottom: 0.625rem;
    line-height: 1.3;

    @media (max-width: 768px) {
      font-size: 1.125rem;
    }
  }

  .content-description {
    font-size: 0.875rem;
    color: $text-gray;
    line-height: 1.5;
    margin-bottom: 1.25rem;

    @media (max-width: 768px) {
      font-size: 0.8125rem;
    }
  }
}

// Liste de features ultra compacte
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0;
}

.feature-item-mini {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .check-icon {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      font-size: 9px;
      color: #fff;
    }
  }

  span {
    font-size: 0.8125rem;
    color: $text-dark;
    line-height: 1.4;
  }
}

// Taap claim box - version compacte
.taap-claim {
  margin-top: 1.25rem;
  padding: 0.875rem;
  background-color: #fff;
  border: 1px solid $border-color;
  border-radius: 8px;

  .claim-label {
    font-size: 0.75rem;
    color: $text-gray;
    margin-bottom: 0.5rem;
  }

  .claim-input-group {
    display: flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid $border-color;
    border-radius: 6px;
    overflow: hidden;

    @media (max-width: 576px) {
      flex-wrap: wrap;
    }

    .input-prefix {
      padding: 0 0.625rem;
      font-weight: 500;
      font-size: 0.8125rem;
      color: $text-dark;
      white-space: nowrap;
    }

    .claim-input {
      flex: 1;
      border: none;
      outline: none;
      padding: 0.5rem;
      font-size: 0.8125rem;
      min-width: 80px;
      background: transparent;

      &::placeholder {
        color: #adb5bd;
      }
    }

    .btn-start {
      background-color: #000;
      color: #fff;
      border: none;
      padding: 0.5rem 1rem;
      font-size: 0.8125rem;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.25s ease;
      white-space: nowrap;
      text-decoration: none;
      display: inline-block;
      text-align: center;

      &:hover {
        background-color: #333;
        color: #fff;
      }

      @media (max-width: 576px) {
        width: 100%;
      }
    }
  }
}

// Cards badges (NFC) - version fine
.cards-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.card-badge {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 0.875rem;
  border-radius: 6px;
  transition: all 0.25s ease;
  cursor: default;

  &:hover {
    transform: translateX(3px);
  }

  .badge-label {
    font-weight: 600;
    font-size: 0.8125rem;
  }

  .badge-desc {
    font-size: 0.6875rem;
    color: rgba($text-dark, 0.7);
  }

  &.white {
    background-color: #fff;
    border: 1px solid #d1d5db;
    color: $text-dark;
  }

  &.silver {
    background: linear-gradient(135deg, #e8e8e8, #c0c0c0);
    color: $text-dark;
    border: 1px solid #b8b8b8;
  }

  &.golden {
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    color: $text-dark;
    border: 1px solid #e6c200;
  }
}

// Visual boxes
.visual-box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 280px; // Réduit pour couper le mockup
  max-height: 280px; // Hauteur fixe
  padding: 1rem;
  overflow: hidden; // Coupe ce qui dépasse

  @media (max-width: 992px) {
    min-height: 240px;
    max-height: 240px;
  }

  @media (max-width: 576px) {
    min-height: 200px;
    max-height: 200px;
  }

  // Image des cartes NFC (reste normale)
  .preview-img {
    max-width: 85%;
    max-height: 240px;
    height: auto;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    object-fit: contain;

    @media (max-width: 992px) {
      max-height: 200px;
      max-width: 90%;
    }

    @media (max-width: 576px) {
      max-width: 100%;
      max-height: 180px;
    }
  }

  // Mockups mobiles - Zoomés et coupés net (pas de fondu)
  .preview-img-mockup {
    max-width: 150%;
    max-height: 480px;
    height: auto;
    border-radius: 10px;
    object-fit: contain;
    transform: scale(1.2); // Zoom pour voir le contenu

    @media (max-width: 992px) {
      max-height: 420px;
      transform: scale(1.15);
    }

    @media (max-width: 576px) {
      max-height: 360px;
      transform: scale(1.1);
    }
  }
}

// Animations
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

// Mockups mobiles - Zoomés et coupés net (pas de fondu)
.preview-img-mockup {
  max-width: 150%;
  max-height: 480px;
  height: auto;
  border-radius: 10px;
  object-fit: contain;
  transform: scale(1.2);

  @media (max-width: 992px) {
    max-height: 420px;
    transform: scale(1.15);
  }

  @media (max-width: 576px) {
    max-height: 360px;
    transform: scale(1.1);
  }
}



// Style spécifique pour Link in Bio - montre le header du profil en haut


// Style spécifique pour Link in Bio - montre le header du profil en haut
.preview-img-profile {
  transform: scale(1.2) translateY(120px) !important; // Valeur POSITIVE pour monter
  
  @media (max-width: 992px) {
    transform: scale(1.15) translateY(100px) !important;
  }
  
  @media (max-width: 576px) {
    transform: scale(1.1) translateY(80px) !important;
  }
}
</style>